import PropTypes from 'prop-types';

export const giftedAudiobookCandidateProps = {
  id: PropTypes.number,
  gifteeEmail: PropTypes.string,
  gifteeName: PropTypes.string,
  fromName: PropTypes.string,
  deliveryDate: PropTypes.string,
  displayDeliveryDate: PropTypes.string,
  message: PropTypes.string,
};

export const giftedAudiobookCandidate = PropTypes.shape(giftedAudiobookCandidateProps);
